import { Box, Heading, HeadingText, HeadingSubtext } from '@gusto/workbench';
import type { LeadFormHeadingProps } from './types';

export default function LeadFormHeading({ heading, subheading, textAlign }: LeadFormHeadingProps) {
  return (
    <Box textAlign={textAlign}>
      <Heading level={4} typePreset="725">
        <HeadingText>{heading}</HeadingText>
        <HeadingSubtext color="salt.1000">
          <p className="text-default">{subheading}</p>
        </HeadingSubtext>
      </Heading>
    </Box>
  );
}
